module.exports = __webpack_public_path__ + "img/icon.72ec0504.svg";